import unescapedText from 'I18n/utils/unescapedText';
import { BY_PRODUCT as HUBSPOT_FEATURES_BY_PRODUCT } from 'ecosystem-marketplace-core/constants/groupTags/hubspotFeatures';
import FilterToggleGroup from 'marketplace-ui-common/filters/components/filterToggleGroup/FilterToggleGroup';
import { getHubSpotFeatureI18nKey } from 'marketplace-ui-common/utils/i18n';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const hubspotFeaturesMap = {
  crm: HUBSPOT_FEATURES_BY_PRODUCT.CRM,
  marketing: HUBSPOT_FEATURES_BY_PRODUCT.MARKETING,
  sales: HUBSPOT_FEATURES_BY_PRODUCT.SALES,
  service: HUBSPOT_FEATURES_BY_PRODUCT.SERVICE,
  content: HUBSPOT_FEATURES_BY_PRODUCT.CMS,
  ops: HUBSPOT_FEATURES_BY_PRODUCT.OPS
};
function getOptions() {
  return Object.entries(hubspotFeaturesMap).map(([groupKey, features]) => {
    return {
      options: Object.values(features).map(featureKey => ({
        text: unescapedText(getHubSpotFeatureI18nKey(featureKey)),
        value: featureKey
      })),
      text: unescapedText(`appMarketplace.storefront.filters.hubspotFeatures.items.${groupKey}`)
    };
  });
}
function HubSpotFeaturesFilter({
  onChange,
  trackInteraction,
  value
}) {
  const [searchTracked, setSearchTracked] = useState(false);
  return /*#__PURE__*/_jsx(FilterToggleGroup, {
    ariaLabel: unescapedText('appMarketplace.storefront.filters.hubspotFeatures.titleText'),
    multi: true,
    name: "hubspot-features",
    onChange: onChange,
    onSearchBlur: () => setSearchTracked(false),
    onSearchChange: event => {
      const search = event.target.value;
      if (searchTracked || !search.trim()) return;
      trackInteraction('search hubspot features');
      setSearchTracked(true);
    },
    options: getOptions(),
    searchable: true,
    searchPlaceholder: unescapedText('appMarketplace.storefront.filters.hubspotFeatures.searchInputPlaceholder'),
    value: value
  });
}
export default HubSpotFeaturesFilter;